import React from 'react';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Image from '@tcp/core/src/components/common/atoms/Image';
import { getIconPath } from '@tcp/core/src/utils';

const ErrorMessage = (errorMessage, showAddToBagCTA) => {
  return errorMessage ? (
    <BodyCopy
      className={!showAddToBagCTA ? 'size-error' : 'default-error'}
      fontSize="fs12"
      component="div"
      fontFamily="secondary"
      fontWeight="regular"
      role="alert"
      aria-live="assertive"
    >
      <Image
        alt="Error"
        className="error-image"
        src={getIconPath('circle-alert-fill')}
        data-locator="productcustomizeform-error-icon"
      />
      <BodyCopy
        className="size-error-message"
        fontSize="fs12"
        component="div"
        fontFamily="secondary"
        fontWeight="regular"
      >
        {` ${errorMessage}`}
      </BodyCopy>
    </BodyCopy>
  ) : null;
};

export default ErrorMessage;
